(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-foundation-hero"] && !Shopify.designMode) return;
  try {
    
  function animateFoundationHeroStat(statElement) {
    if (!statElement || statElement.dataset.statAnimated === 'true') return;

    const valueElement = statElement.querySelector('.home-foundation-hero__stat-value');
    if (!valueElement) return;

    const targetCount = Math.max(parseInt(statElement.dataset.jobsTarget, 10) || 0, 0);
    const targetProgress = Math.min(Math.max(parseFloat(statElement.dataset.progressTarget) || 0, 0), 100);

    const setState = (count, progress) => {
      statElement.style.setProperty('--foundation-home-hero-stat-progress', String(progress));
      valueElement.textContent = String(count);
    };

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setState(targetCount, targetProgress);
      statElement.dataset.statAnimated = 'true';
      return;
    }

    const duration = 1800;
    const startTime = performance.now();
    const smoothstep = (edge0, edge1, x) => {
      const normalizedValue = Math.min(Math.max((x - edge0) / (edge1 - edge0), 0), 1);
      return normalizedValue * normalizedValue * (3 - 2 * normalizedValue);
    };
    const blend = (startValue, endValue, amount) => startValue + (endValue - startValue) * amount;
    const stagedProgress = (timeProgress) => {
      const firstBreakpoint = 0.12;
      const secondBreakpoint = 0.42;
      const transitionWidth = 0.035;

      const firstSegmentSlope = 0.5 / firstBreakpoint;
      const secondSegmentSlope = 0.25 / (secondBreakpoint - firstBreakpoint);
      const thirdSegmentSlope = 0.25 / (1 - secondBreakpoint);

      const firstValue = timeProgress * firstSegmentSlope;
      const secondValue = 0.5 + (timeProgress - firstBreakpoint) * secondSegmentSlope;
      const thirdValue = 0.75 + (timeProgress - secondBreakpoint) * thirdSegmentSlope;

      if (timeProgress < firstBreakpoint - transitionWidth) return firstValue;

      if (timeProgress <= firstBreakpoint + transitionWidth) {
        return blend(
          firstValue,
          secondValue,
          smoothstep(firstBreakpoint - transitionWidth, firstBreakpoint + transitionWidth, timeProgress)
        );
      }

      if (timeProgress < secondBreakpoint - transitionWidth) return secondValue;

      if (timeProgress <= secondBreakpoint + transitionWidth) {
        return blend(
          secondValue,
          thirdValue,
          smoothstep(secondBreakpoint - transitionWidth, secondBreakpoint + transitionWidth, timeProgress)
        );
      }

      return thirdValue;
    };

    const tick = (now) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const curvedProgress = stagedProgress(progress);

      setState(Math.round(targetCount * curvedProgress), targetProgress * curvedProgress);

      if (progress < 1) {
        requestAnimationFrame(tick);
        return;
      }

      setState(targetCount, targetProgress);
      statElement.dataset.statAnimated = 'true';
    };

    requestAnimationFrame(tick);
  }

  function initializeFoundationHeroStats(rootElement = document) {
    const statElements = rootElement.querySelectorAll('.home-foundation-hero__stat[data-jobs-target][data-progress-target]');
    if (!statElements.length) return;

    statElements.forEach((statElement) => {
      if (statElement.dataset.statObserverBound === 'true' || statElement.dataset.statAnimated === 'true') return;

      statElement.dataset.statObserverBound = 'true';

      const observer = new IntersectionObserver(
        (entries, entryObserver) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            animateFoundationHeroStat(entry.target);
            entryObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.2 }
      );

      observer.observe(statElement);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initializeFoundationHeroStats());

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => initializeFoundationHeroStats(event.target));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-testimonials"] && !Shopify.designMode) return;
  try {
    
  function initializeHomeTestimonials(root = document) {
    root.querySelectorAll('[data-home-testimonials]').forEach((section) => {
      if (section.dataset.homeTestimonialsInitialized === 'true') return;

      const slides = Array.from(section.querySelectorAll('[data-home-testimonials-slide]'));
      const previousButton = section.querySelector('[data-home-testimonials-previous]');
      const nextButton = section.querySelector('[data-home-testimonials-next]');
      let activeIndex = Math.max(slides.findIndex((slide) => slide.classList.contains('is-active')), 0);

      const showSlide = (nextIndex) => {
        if (!slides.length) return;
        activeIndex = (nextIndex + slides.length) % slides.length;

        slides.forEach((slide, index) => {
          const isActive = index === activeIndex;
          slide.classList.toggle('is-active', isActive);
          slide.hidden = !isActive;
        });
      };

      previousButton?.addEventListener('click', () => showSlide(activeIndex - 1));
      nextButton?.addEventListener('click', () => showSlide(activeIndex + 1));
      showSlide(activeIndex);
      section.dataset.homeTestimonialsInitialized = 'true';
    });
  }

  document.addEventListener('DOMContentLoaded', () => initializeHomeTestimonials());

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => initializeHomeTestimonials(event.target));
  }

  } catch(e) { console.error(e); }
})();
})();
